/* global DISPLAY_DATE_FORMAT */

import PropTypes from 'prop-types'
import React from 'react'
import Rodal from 'rodal'

import 'rodal/lib/rodal.css'
import './styles.css'

function RetentionDialog({
  isMobile,
  cancel,
  subscription,
  open,
  onClose,
  acceptRetentionDiscount,
  isDisabled
}) {
  const onCloseDialog = () => {
    onClose()
  }

  return (
    <Rodal
      visible={open}
      onClose={onCloseDialog}
      width={isMobile ? 335 : 600}
      height={430}
      animation="fade"
      className="confirmation"
    >
      <div className="subscription-section confirmation" id="RetentionDialog">
        <div className="header">
          <h2>Before you go</h2>
        </div>
        <div className="dialog-content">
          <p>
            WAIT! Before you go, we’d love to offer you something to stay
            connected.{' '}
          </p>
          <p>
            Instead of canceling your subscription, you can stay on your current
            plan and{' '}
            <b>get {subscription?.cancellationDiscountPercentage}% off</b> your
            subscription going forward. No changes, no interruptions.
          </p>
        </div>
        <div className="action-buttons">
          <button
            type="button"
            onClick={() => {
              acceptRetentionDiscount()
            }}
            className="btn -mini -orange"
            disabled={isDisabled}
          >
            {`Stay Subscribed & Save ${subscription?.cancellationDiscountPercentage}%`}
          </button>
          <button
            onClick={() => {
              cancel()
            }}
            className="cancel-anyway-btn"
            type="button"
            disabled={isDisabled}
          >
            Continue to cancel
          </button>
        </div>
      </div>
    </Rodal>
  )
}

RetentionDialog.propTypes = {
  isMobile: PropTypes.bool.isRequired
}

export default RetentionDialog
